module.exports = __webpack_public_path__ + "img/Flag_of_Senegal.ff8fa9bb.svg";